<div class="mx-auto flex max-w-2xl flex-col">
  <div class="mb-4 h-8 w-8">
    <app-left-arrow-icon
      class="cursor-pointer"
      (click)="location.back()"
    ></app-left-arrow-icon>
  </div>

  <div>
    <h1 class="mb-4 text-2xl font-bold">Edit Subscription</h1>
  </div>

  @if (errorFetchingSubscription) {
    <div class="mt-4">
      <p class="text-error">{{ errorFetchingSubscription }}</p>
    </div>
  } @else if (loadingSubscription) {
    <div class="mt-4 text-center">
      <div class="loading loading-spinner"></div>
    </div>
  } @else if (!originalSubscription || !tenant) {
    <div class="mt-4">
      <p class="text-error">No license or tenant data</p>
    </div>
  } @else {
    <div class="mb-4">
      <div class="flex justify-between space-x-8">
        <div>
          <div class="mb-2">
            <h4 class="text-md font-bold">Account Number</h4>
            <p class="text-sm">{{ tenant.account_number }}</p>
          </div>
          <div class="mb-2">
            <h4 class="text-md font-bold">Product</h4>
            <p class="text-sm">{{ originalSubscription.api_product.title }}</p>
          </div>
        </div>
      </div>

      <hr class="my-4 border-base-content/50" />

      <div class="form-control mb-4 w-full">
        <label class="label">
          <span class="label-text">Admin notes</span>
        </label>
        <textarea
          class="textarea textarea-bordered min-h-24 w-full"
          [(ngModel)]="inputNotes"
          placeholder="Internal notes (not visible to customers)"
        ></textarea>
      </div>

      <div class="form-control mb-2 w-fit">
        <label class="label">
          <span class="label-text">Start Date</span>
        </label>
        <input
          type="date"
          class="input input-bordered"
          [(ngModel)]="inputStartDate"
        />
      </div>

      <div class="form-control mb-2 w-fit">
        <label class="label cursor-pointer">
          <input type="checkbox" class="checkbox" [(ngModel)]="active" />
          <span class="label-text ml-4">Active</span>
        </label>
      </div>
      <div class="mb-2 py-2">
        <button class="btn btn-error" (click)="showConfirmDeleteDialog()">
          Delete Subscription
        </button>
      </div>
      <div class="mt-8 flex w-fit">
        <button
          class="btn btn-primary"
          [disabled]="!hasChanges || updating"
          (click)="updateSubscription()"
        >
          Save Changes
        </button>

        @if (updating) {
          <div class="ml-4 flex content-center">
            <div class="loading loading-spinner"></div>
          </div>
        }
      </div>
    </div>
  }

  @if (errorUpdating) {
    <div class="mt-4">
      <p class="text-error">{{ errorUpdating }}</p>
    </div>
  }
</div>

<dialog class="modal" #deleteSubscriptionDialog>
  <div class="modal-box max-w-3xl p-8">
    <h3 class="text-lg font-bold">Confirm Subscription Deletion</h3>

    <p class="mt-8 text-sm text-error">
      This deletion is permanent. Are you sure you want to delete this
      subscription?
    </p>

    <div class="mt-4 flex justify-end">
      @if (deletingSubscription) {
        <div class="loading loading-spinner mr-4"></div>
      }
      <button
        class="btn btn-error mr-4"
        (click)="deleteSubscription()"
        [disabled]="deletingSubscription"
      >
        Delete
      </button>
      <button class="btn btn-neutral" (click)="closeDeleteSubscriptionDialog()">
        Cancel
      </button>
    </div>
  </div>
</dialog>
